import React, { useCallback, useEffect, useState, useRef, createElement } from 'react';
import { Check, Star, AlertTriangle, Hammer, BookOpen, ShieldCheck, Lock, CreditCard, Wrench, Layout, ChevronDown, Zap, Download, HelpCircle, Brain, DollarSign, MessageSquare, X, ChevronLeft, ChevronRight, TrendingUp } from 'lucide-react';
const MAIN_PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/a53GoZChi4D4KXXg2vPEsN/naQNb_l4Tge_o_3mPcStbw2k.webp';
const NEW_HERO_IMG = 'https://cdn.magicpatterns.com/uploads/4JGpGnPGrKuWJEhRz4fcSM/Diseno_sin_titulo_(1).png';
const MERCADO_PAGO_CHECKOUT = 'https://cdn.magicpatterns.com/uploads/jkgxfSii45fTiBQ4YfyPYV/mercadopago2.jpg';
const BUNDLE_HERO_IMG = 'https://cdn.magicpatterns.com/uploads/eZ9vqieemzRzScwfScAkC3/_bWADyqANS36Osq2xWSZ4ag_Uhd7XL9ASTiwWyQ4L3RkFA_4k.png';
const MERCADO_PAGO_IMG = 'https://cdn.magicpatterns.com/uploads/xm4qavEQc5iVme5Wmyo3hK/medios-de-pago-640x640.png';
const HEADER_LOGO = 'https://cdn.magicpatterns.com/uploads/bHhkj1c2stkPnwrsvUX5bY/Diseno_sin_titulo_(3).png';
const MAIN_CHECKOUT_URL = 'https://checkout.maestrosindustriales.shop/cart/47957399109880:1';
const STICKY_ICON = 'https://cdn.magicpatterns.com/uploads/bHhkj1c2stkPnwrsvUX5bY/Diseno_sin_titulo_(3).png';
const COMPRA_SEGURA_IMG = 'https://cdn.magicpatterns.com/uploads/s9ioLDDqLpMwzzKeigXiQX/safe-purchase-7779878_1280.png';
const GARANTIA_IMG = 'https://cdn.magicpatterns.com/uploads/oNZ7aT7mecdQjh23Py1dkd/Selo-de-Garantia-de-7-Dias-PNG-Transparente-Sem-Fundo-1.png';
const CAROUSEL_IMAGES = ['https://cdn.magicpatterns.com/uploads/tuFoxUDEqhmxQX8maY7Rmk/Mercado_Libre.jpg', 'https://cdn.magicpatterns.com/uploads/pPJvXWY4bJL9dZW8mG2CW1/descarga.jpg', 'https://cdn.magicpatterns.com/uploads/1w3JTtAaPhJNXT5LstEj3s/Carro_de_arrastre.jpg', 'https://cdn.magicpatterns.com/uploads/9Hy3tgreCntYzcxpWPGre4/Estante_Vision_Light.jpg', 'https://cdn.magicpatterns.com/uploads/nBMzSC4jQoptTazs6eMxPf/Idea_for_elevated_shelf_coffee_bar.jpg', 'https://cdn.magicpatterns.com/uploads/79WBidoMhCcGVc2EV4vgM7/a2d8fd5e5a54797f1ead28787fc39cf9.jpg', 'https://cdn.magicpatterns.com/uploads/ijYXMTa5aQAoH4kWS84skC/descarga_(1).jpg', 'https://cdn.magicpatterns.com/uploads/isxqumkJKYCsuGMmceuzLF/d02ffcf8523b664ae13ecd3c80313403.jpg', 'https://cdn.magicpatterns.com/uploads/phyW8vHdEZv7yVwzueRKXE/Custom_Natural_Wood_Bookshelves.jpg'];
const EBOOK_PREVIEW_IMAGES = ['https://cdn.magicpatterns.com/uploads/w8C5g6BQpeT4rfYefSxVX2/capture_260131_162524.png', 'https://cdn.magicpatterns.com/uploads/sosZXNubdXe7um5YBtv71j/capture_260131_162625.png', 'https://cdn.magicpatterns.com/uploads/4TxwABQPhvZoSkUXR4NnZK/capture_260131_162636.png', 'https://cdn.magicpatterns.com/uploads/9NSEHn1wM1kuk4rJqZZ6DP/capture_260131_162930.png', 'https://cdn.magicpatterns.com/uploads/6xLj3uTRfgy2HuP6DX9qu1/capture_260131_163022.png', 'https://cdn.magicpatterns.com/uploads/rE6SM2zVSp4LMib3opo6LD/capture_260228_170726.png', 'https://cdn.magicpatterns.com/uploads/hxGkKDiw3VSryFywVv8BXu/capture_260228_170721.png', 'https://cdn.magicpatterns.com/uploads/mmwtyKuXZA6rbSVtDpwBKu/capture_260228_170715.png'];
const BONUS_IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/t8xEtDJda4yLe3pxg4aBuu/Diseno_sin_titulo_(3).png',
  title: 'BONO PREMIUM: MÁQUINAS DE GIMNASIO RENTABLES (+200 PLANOS)',
  desc: '+200 PLANOS AHORA de fabricación de máquinas de gimnasio industriales. Edición especial con diseños probados de alta demanda.',
  price: '$45.000 ARS',
  isPremium: true
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bsNuHGEFA4vXVMzB8Zb749/_hvsfq7UVS0ati8NEDewDqw_yRVWzHnITfOLECFjx49Q-g_2k.png',
  title: 'MÓDULO 1: Planos para Muebles Rentables',
  desc: 'Diseños listos para cortar y armar, pensados para productos de alta demanda.',
  price: '$10.700 ARS'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/p2N8UbnH5SUvSsccZEgq4M/vpRUikLCRcKY6us7VndvfQ2k.webp',
  title: 'MÓDULO 2: Sistema de Presupuesto',
  desc: 'Calculadora para cobrar lo justo y ganar más en cada trabajo.',
  price: '$8.900 ARS'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/i5QEvD9WY8kDHkpzozLjDt/_D3cFzWo8ST2Ggzz4TBGB4g_yBMj4frJQrOCy_cvImW-6g_2k.png',
  title: 'MÓDULO 3: Manual de Soldadura',
  desc: 'Técnicas fundamentales para lograr estructuras firmes y prolijas.',
  price: '$12.500 ARS'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/prJbjXeLzJJTwUZq9js8xs/_xR4h7ZpIQvmpw6Llrpwj3g_G8TJHEpaQc6UK_gxXcX2bQ_2k.png',
  title: 'MÓDULO 4: Formación Teórica',
  desc: 'La base del conocimiento industrial para evitar errores costosos.',
  price: '$9.800 ARS'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/gDKgXCpfa8Z5k34F5H4JSS/ikvNh9P4SJ2OiUcz47WycA2k.webp',
  title: 'MÓDULO 5: Proyectos de Trailers y Portones',
  desc: '12 diseños listos para fabricar y vender, incluye planos completos de trailers y portones.',
  price: '$14.200 ARS'
}];
const CURATED_REVIEWS = [{
  name: 'Carlos M.',
  location: 'Buenos Aires',
  rating: 5,
  text: 'Yo laburo en herrería hace años y siempre improvisaba. Con los planos estos arranqué a trabajar más ordenado. Se nota la diferencia.'
}, {
  name: 'Luis R.',
  location: 'Córdoba',
  rating: 5,
  text: 'Pensé que era otro PDF más, pero la verdad están bien explicados y listos para usar. Ya hice dos trabajos sin renegar.'
}, {
  name: 'Martín G.',
  location: 'Rosario',
  rating: 4,
  text: 'Muy bueno, me ayudó a ordenar el laburo. Lo recomiendo.'
}, {
  name: 'Diego P.',
  location: 'Mendoza',
  rating: 5,
  text: 'Muy práctico. Para el que fabrica seguido, esto ahorra tiempo y errores.'
}, {
  name: 'Jorge S.',
  location: 'Santa Fe',
  rating: 5,
  text: 'Excelente material. Los planos de los trailers me sirvieron para agarrar un laburo grande.'
}, {
  name: 'Pablo D.',
  location: 'Tucumán',
  rating: 4,
  text: 'Buen material, lo estoy usando bastante. Cumple con lo que promete.'
}, {
  name: 'Fernando A.',
  location: 'Neuquén',
  rating: 5,
  text: 'Soy hobbista y me animé a hacer mi primera mesa. Quedó espectacular.'
}, {
  name: 'Ricardo V.',
  location: 'Mar del Plata',
  rating: 5,
  text: 'Buena info, directa al grano. Sin vueltas.'
}];
const RECENT_SALES = ['Martín de Buenos Aires', 'José de Ciudad de México', 'Andrés de Bogotá', 'Luis de Lima', 'Pablo de Santiago', 'Ricardo de Montevideo', 'Eduardo de Guadalajara'];
const FAQ_DATA = [{
  q: '¿Necesito experiencia previa para usar los planos?',
  a: 'No. Los planos están pensados tanto para quienes recién empiezan como para herreros con experiencia. Todo está explicado paso a paso, con medidas claras y criterio industrial.'
}, {
  q: '¿Qué tipo de proyectos voy a poder fabricar?',
  a: 'Muebles industriales, estructuras, portones, rejas, trailers y otros proyectos rentables. Son diseños probados y pensados para vender.'
}, {
  q: '¿En qué formato recibo el material?',
  a: 'Todo el contenido se entrega en formato digital (PDF y carpetas organizadas), listo para descargar y usar.'
}, {
  q: '¿El acceso es inmediato?',
  a: 'Sí. Apenas se confirma el pago, recibís el acceso automático al material completo.'
}, {
  q: '¿Puedo usar los planos para trabajar y vender?',
  a: 'Sí. Los planos están pensados para que fabriques y vendas tus propios proyectos sin improvisar.'
}, {
  q: '¿Tiene garantía?',
  a: 'Sí. Tenés 7 días de garantía. Si el material no es lo que esperabas, podés solicitar la devolución.'
}];
const useInView = (options = {}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isInView, setIsInView] = useState(false);
  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsInView(true);
        observer.unobserve(element);
      }
    }, {
      threshold: 0.1,
      ...options
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);
  return {
    ref,
    isInView
  };
};
const ScrollReveal = ({
  children,
  className = '',
  delay = 0,
  type = 'fade-down'
}: {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  type?: 'fade-down' | 'fade-up' | 'fade-left' | 'fade-right' | 'zoom' | 'float-up';
}) => {
  const {
    ref,
    isInView
  } = useInView({
    threshold: 0.15
  });
  const baseDelay = typeof delay === 'number' ? delay * 0.15 : 0;
  const hiddenTransform = type === 'fade-down' ? 'translateY(-24px)' : type === 'fade-up' ? 'translateY(24px)' : type === 'fade-left' ? 'translateX(-20px)' : type === 'fade-right' ? 'translateX(20px)' : type === 'zoom' ? 'scale(0.96)' : 'translateY(16px)';
  return <div ref={ref} className={className} style={{
    opacity: isInView ? 1 : 0,
    transform: isInView ? 'translateY(0) translateX(0) scale(1)' : hiddenTransform,
    transition: `opacity 1s ease-out ${baseDelay}s, transform 1s ease-out ${baseDelay}s`
  }} data-id="element-0">
      {children}
    </div>;
};
const MetaPixel = () => {
  useEffect(() => {
    const existingScripts = document.querySelectorAll('script[src*="fbevents.js"]');
    existingScripts.forEach(script => script.remove());
    if ((window as any).fbq) {
      delete (window as any).fbq;
      delete (window as any)._fbq;
    }
    const script = document.createElement('script');
    script.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','1951517502462967');fbq('track','PageView');fbq('track', 'ViewContent', { content_name: 'Maestro de Muebles Industriales', content_category: 'Digital Product' });`;
    document.head.appendChild(script);
  }, []);
  return null;
};
const SocialProofPopup = () => {
  const [visible, setVisible] = useState(false);
  const [text, setText] = useState('');
  useEffect(() => {
    const showPopup = () => {
      const randomName = RECENT_SALES[Math.floor(Math.random() * RECENT_SALES.length)];
      setText(`${randomName} acaba de comprar este libro`);
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    };
    const initialTimer = setTimeout(showPopup, 10000);
    const loop = () => {
      const nextTime = Math.random() * 20000 + 20000;
      setTimeout(() => {
        showPopup();
        loop();
      }, nextTime);
    };
    const loopTimer = setTimeout(loop, 20000);
    return () => {
      clearTimeout(initialTimer);
      clearTimeout(loopTimer);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50" data-id="element-1">
      <div className="bg-neutral-900/95 backdrop-blur border border-green-500/30 text-white px-3 py-2 rounded-lg shadow-xl flex items-center gap-3 max-w-[280px]" data-id="element-2">
        <div className="w-8 h-8 rounded-full flex items-center justify-center bg-green-500/20 flex-shrink-0" data-id="element-3">
          <Check className="w-5 h-5 text-green-400" data-id="element-4" />
        </div>
        <div data-id="element-5">
          <p className="text-xs font-medium leading-tight" data-id="element-6">{text}</p>
          <p className="text-[10px] text-neutral-400 mt-0.5" data-id="element-7">
            Hace unos instantes
          </p>
        </div>
      </div>
    </div>;
};
const ScrollToBuy = ({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div onClick={handleClick} className={`cursor-pointer ${className}`} data-id="element-8">
      {children}
    </div>;
};
const StickyHeader = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 transform ${visible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'} bg-neutral-950/95 backdrop-blur-sm border-b border-neutral-800 py-2 shadow-lg`} data-id="element-9">
      <div className="max-w-6xl mx-auto px-4 flex justify-between items-center" data-id="element-10">
        <div className="flex items-center gap-2" data-id="element-11">
          <img src={HEADER_LOGO} alt="Maestro Industrial" className="h-8 md:h-10 w-auto object-contain" data-id="element-12" />
          <span className="font-bold text-white text-sm hidden sm:block" data-id="element-13">
            MAESTRO INDUSTRIAL
          </span>
        </div>
        <ScrollToBuy data-id="element-14">
          <button className="relative overflow-hidden bg-yellow-500 hover:bg-yellow-400 text-black text-xs font-bold py-2 px-4 rounded transition-colors shadow-lg shadow-yellow-500/20 animate-shine animate-header-shake" data-id="element-15">
            Acceder Ahora
          </button>
        </ScrollToBuy>
      </div>
    </div>;
};
const CTAButton = ({
  text,
  subtext,
  className = '',
  pulse = false
}: {
  text: string;
  subtext?: string;
  className?: string;
  pulse?: boolean;
}) => <ScrollToBuy className="w-full flex justify-center" data-id="element-16">
    <button className={`group relative overflow-hidden bg-yellow-400 hover:bg-yellow-300 text-neutral-900 font-black py-4 px-8 rounded-lg shadow-lg shadow-yellow-500/30 transition-all duration-300 w-full max-w-md text-center transform hover:scale-[1.02] animate-shine ${pulse ? 'animate-glow-pulse' : ''} ${className}`} data-id="element-17">
      <span className="relative z-10 flex flex-col items-center justify-center gap-1" data-id="element-18">
        <span className="text-lg md:text-xl uppercase tracking-wide font-black" data-id="element-19">
          {text}
        </span>
        {subtext && <span className="text-xs font-normal opacity-90" data-id="element-20">{subtext}</span>}
      </span>
    </button>
  </ScrollToBuy>;
const ProjectsCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const nextSlide = useCallback(() => setCurrentIndex(prev => (prev + 1) % CAROUSEL_IMAGES.length), []);
  const prevSlide = useCallback(() => setCurrentIndex(prev => (prev - 1 + CAROUSEL_IMAGES.length) % CAROUSEL_IMAGES.length), []);
  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(nextSlide, 1800);
    return () => clearInterval(interval);
  }, [isPaused, nextSlide]);
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
    setIsPaused(true);
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    touchEndX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current;
    if (Math.abs(diff) > 50) {
      diff > 0 ? nextSlide() : prevSlide();
    }
    setTimeout(() => setIsPaused(false), 5000);
  };
  return <section className="space-y-8" data-id="element-21">
      <div className="text-center space-y-2" data-id="element-22">
        <ScrollReveal data-id="element-23">
          <h3 className="text-2xl md:text-3xl font-black uppercase text-white" data-id="element-24">
            Proyectos probados que podés fabricar con los planos
          </h3>
        </ScrollReveal>
        <ScrollReveal delay={1} data-id="element-25">
          <p className="text-neutral-400 font-medium text-sm md:text-base" data-id="element-26">
            Más de 600 diseños reales: muebles industriales, trailers, portones,
            máquinas de gym y más.
          </p>
        </ScrollReveal>
      </div>
      <div className="relative overflow-hidden rounded-xl bg-neutral-900 border border-neutral-800 max-w-sm mx-auto" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-id="element-27">
        <div className="flex transition-transform duration-500 ease-in-out" style={{
        transform: `translateX(-${currentIndex * 100}%)`
      }} data-id="element-28">
          {CAROUSEL_IMAGES.map((img, idx) => <div key={idx} className="w-full flex-shrink-0" data-id="element-29">
              <img src={img} alt={`Proyecto ${idx + 1}`} className="w-full aspect-[9/16] object-cover" data-id="element-30" />
            </div>)}
        </div>
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-1.5" data-id="element-31">
          {CAROUSEL_IMAGES.map((_, idx) => <button key={idx} onClick={() => {
          setCurrentIndex(idx);
          setIsPaused(true);
          setTimeout(() => setIsPaused(false), 5000);
        }} className={`w-1.5 h-1.5 rounded-full transition-colors ${idx === currentIndex ? 'bg-yellow-500' : 'bg-neutral-600'}`} data-id="element-32" />)}
        </div>
      </div>
      <p className="text-center text-neutral-500 text-sm" data-id="element-33">
        👉 Deslizá para ver proyectos reales fabricados con los planos
      </p>
    </section>;
};
const FearToSystemCard = () => {
  const {
    ref,
    isInView
  } = useInView();
  return <section ref={ref} className="bg-[#0b0b0b] border border-yellow-500/30 rounded-xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-34">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-transparent via-yellow-500/60 to-transparent" data-id="element-35"></div>
      <h3 className={`text-2xl md:text-4xl font-black text-white leading-tight tracking-tight mb-6 ${isInView ? 'animate-fade-in-down' : 'opacity-0'}`} data-id="element-36">
        Trabajar sin planos no es libertad.
        <br data-id="element-37" />
        <span className="text-white" data-id="element-38">Es trabajar con miedo.</span>
      </h3>
      <div className={`w-12 h-px bg-yellow-500/40 mx-auto mb-6 ${isInView ? 'animate-fade-in-down-delay-1' : 'opacity-0'}`} data-id="element-39"></div>
      <p className={`text-neutral-400 text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-8 ${isInView ? 'animate-fade-in-down-delay-2' : 'opacity-0'}`} data-id="element-40">
        Cuando todo lo pensás en la cabeza, medís de más, dudás y ajustás sobre
        la marcha. Avanzás… pero tenso.
      </p>
      <p className={`text-yellow-500 font-bold text-lg md:text-xl ${isInView ? 'animate-fade-in-down-delay-3' : 'opacity-0'}`} data-id="element-41">
        Los que venden todos los días trabajan con un sistema de planos claros.
      </p>
    </section>;
};
const ProblemsSection = () => <section className="space-y-8" style={{
  backgroundColor: '#0b0b0b'
}} data-id="element-42">
    <div className="text-center space-y-2" data-id="element-43">
      <ScrollReveal data-id="element-44">
        <h3 className="text-3xl md:text-4xl font-black text-red-500 uppercase" data-id="element-45">
          LA REALIDAD DEL TALLER
        </h3>
      </ScrollReveal>
      <ScrollReveal delay={1} data-id="element-46">
        <p className="text-lg text-neutral-300" data-id="element-47">(QUE CASI NADIE DICE)</p>
      </ScrollReveal>
      <ScrollReveal delay={2} data-id="element-48">
        <p className="text-neutral-400 font-medium mt-4" data-id="element-49">
          Si esto te pasa, no es casualidad.
        </p>
      </ScrollReveal>
    </div>
    <ScrollReveal delay={3} data-id="element-50">
      <div className="bg-[#1a1a1a] border-l-4 border-red-500 rounded-lg p-6 md:p-8 space-y-6" data-id="element-51">
        <div className="space-y-6" data-id="element-52">
          {[{
          icon: AlertTriangle,
          title: 'Empezás los proyectos "a ver qué sale"',
          desc: 'Fabricás sin planos claros o, si estás por arrancar, dudás porque no sabés por dónde empezar.'
        }, {
          icon: Wrench,
          title: <>
                  Avanzás, pero con{' '}
                  <span className="text-red-500" data-id="element-53">tensión</span>
                </>,
          desc: <>
                  Medís dos veces. Ajustás sobre la marcha. No estás tranquilo.
                  Estás <span className="text-red-400" data-id="element-54">improvisando</span>.
                </>
        }, {
          icon: Brain,
          title: 'El miedo que no se dice',
          desc: <>
                  No es miedo a equivocarte. Es miedo a que{' '}
                  <span className="text-red-400" data-id="element-55">se note</span>: terminaciones
                  flojas, estructuras inseguras, aspecto casero.
                </>
        }, {
          icon: DollarSign,
          title: 'Y si todavía no arrancaste…',
          desc: 'Miedo a invertir tiempo y materiales sin saber si va a funcionar o no.'
        }].map((item, i) => <div key={i} className="flex gap-4" data-id="element-56">
              <div className="bg-neutral-800 w-10 h-10 rounded-full flex items-center justify-center shrink-0" data-id="element-57">
                <item.icon className="text-red-500 w-5 h-5" data-id="element-58" />
              </div>
              <div data-id="element-59">
                <h4 className="text-lg font-bold text-white mb-2" data-id="element-60">
                  {item.title}
                </h4>
                <p className="text-neutral-400 text-sm" data-id="element-61">{item.desc}</p>
              </div>
            </div>)}
        </div>
        <p className="text-red-400 font-bold text-center pt-4 border-t border-neutral-700" data-id="element-62">
          Frustración, desgaste mental y trabajos que no te representan.
        </p>
      </div>
    </ScrollReveal>
    <ScrollReveal delay={4} data-id="element-63">
      <div className="bg-[#1a1a1a] border-l-4 border-yellow-500 rounded-lg p-6 md:p-8 space-y-4" data-id="element-64">
        <h4 className="text-xl font-black text-yellow-500 uppercase" data-id="element-65">
          El verdadero bloqueo no es la habilidad
        </h4>
        <p className="text-lg text-white font-medium" data-id="element-66">
          Es trabajar sin un sistema.
        </p>
        <p className="text-neutral-300 pt-2" data-id="element-67">
          Los que venden todos los días{' '}
          <span className="text-yellow-500 font-bold" data-id="element-68">no improvisan</span>.
          Trabajan con:
        </p>
        <ul className="space-y-2 pt-2" data-id="element-69">
          {['Planos claros', 'Medidas exactas', 'Estructuras que funcionan'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-70">
              <Check className="w-5 h-5 text-yellow-500 shrink-0" data-id="element-71" />
              <span className="text-yellow-400 font-medium" data-id="element-72">{item}</span>
            </li>)}
        </ul>
        <p className="text-neutral-400 text-sm pt-2" data-id="element-73">
          Y un criterio pensado para fabricar y vender, no para adivinar.
        </p>
      </div>
    </ScrollReveal>
    <div className="space-y-6 pt-8" data-id="element-74">
      <ScrollReveal delay={5} data-id="element-75">
        <div className="flex items-start gap-4" data-id="element-76">
          <X className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-77" />
          <div data-id="element-78">
            <p className="text-white font-bold mb-1" data-id="element-79">Los que improvisan</p>
            <p className="text-neutral-400 text-sm" data-id="element-80">
              Trabajan con{' '}
              <span className="text-red-400 font-medium" data-id="element-81">duda</span>,{' '}
              <span className="text-red-400 font-medium" data-id="element-82">tensión</span> y{' '}
              <span className="text-red-400 font-medium" data-id="element-83">miedo</span> a
              equivocarse.
            </p>
          </div>
        </div>
      </ScrollReveal>
      <ScrollReveal delay={6} data-id="element-84">
        <div className="flex items-start gap-4" data-id="element-85">
          <Check className="w-6 h-6 text-green-500 shrink-0 mt-0.5" data-id="element-86" />
          <div data-id="element-87">
            <p className="text-white font-bold mb-1" data-id="element-88">
              Los que trabajan con sistema
            </p>
            <p className="text-neutral-400 text-sm" data-id="element-89">
              Ejecutan con{' '}
              <span className="text-green-400 font-medium" data-id="element-90">seguridad</span>,
              avanzan <span className="text-green-400 font-medium" data-id="element-91">rápido</span>{' '}
              y cobran con{' '}
              <span className="text-green-400 font-medium" data-id="element-92">confianza</span>.
            </p>
          </div>
        </div>
      </ScrollReveal>
    </div>
  </section>;
const BonusesSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [bonusCupos, setBonusCupos] = useState(13);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  useEffect(() => {
    // Decrement bonus cupos from 13 to 2, synced pace with payment card
    const timers: ReturnType<typeof setTimeout>[] = [];
    const scheduleNext = () => {
      const t = setTimeout(() => {
        setBonusCupos(prev => {
          if (prev > 2) return prev - 1;
          return prev;
        });
        scheduleNext();
      }, 40000 + Math.random() * 60000);
      timers.push(t);
    };
    scheduleNext();
    return () => timers.forEach(clearTimeout);
  }, []);
  const itemsPerSlide = isMobile ? 1 : 2;
  const maxIndex = Math.ceil(BONUS_IMAGES.length / itemsPerSlide) - 1;
  const nextSlide = useCallback(() => setCurrentIndex(prev => prev >= maxIndex ? 0 : prev + 1), [maxIndex]);
  const prevSlide = useCallback(() => setCurrentIndex(prev => prev <= 0 ? maxIndex : prev - 1), [maxIndex]);
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    touchEndX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current;
    if (Math.abs(diff) > 50) {
      diff > 0 ? nextSlide() : prevSlide();
    }
  };
  return <section className="space-y-12" data-id="element-93">
      <div className="text-center space-y-2" data-id="element-94">
        <ScrollReveal data-id="element-95">
          <span className="inline-block bg-neutral-800 border border-yellow-500/50 text-yellow-500 text-xs font-bold uppercase px-4 py-1 rounded-full" data-id="element-96">
            ACCESO ESPECIAL DISPONIBLE HOY
          </span>
        </ScrollReveal>
        <ScrollReveal delay={1} data-id="element-97">
          <h3 className="text-3xl md:text-4xl font-black text-yellow-500 uppercase" data-id="element-98">
            ACCESO COMPLETO + 6 BONOS INCLUIDOS
          </h3>
        </ScrollReveal>
        <ScrollReveal delay={2} data-id="element-99">
          <p className="text-neutral-400 font-medium" data-id="element-100">
            Todo lo que recibís con tu acceso
          </p>
          <p className="text-neutral-500 text-xs mt-2" data-id="element-101">
            Oferta de bonos válida solo por hoy:{' '}
            {new Date().toLocaleDateString('es-AR', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          })}
          </p>
        </ScrollReveal>
      </div>
      <div className="relative px-4 md:px-12" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} data-id="element-102">
        <div className="overflow-hidden" data-id="element-103">
          <div className="flex transition-transform duration-500 ease-in-out" style={{
          transform: `translateX(-${currentIndex * 100}%)`
        }} data-id="element-104">
            {Array.from({
            length: Math.ceil(BONUS_IMAGES.length / itemsPerSlide)
          }).map((_, slideIndex) => <div key={slideIndex} className="w-full flex-shrink-0 flex gap-6 px-1" data-id="element-105">
                {BONUS_IMAGES.slice(slideIndex * itemsPerSlide, (slideIndex + 1) * itemsPerSlide).map((bonus: any, idx: number) => <div key={idx} className={`w-full ${isMobile ? 'flex-1' : 'w-1/2'}`} data-id="element-106">
                    {bonus.isPremium ? <ScrollToBuy className="h-full group relative bg-neutral-950 rounded-xl overflow-hidden border-2 border-red-500 shadow-2xl animate-border-blink-red flex flex-col" data-id="element-107">
                        {/* Animated fire gradient background */}
                        <div className="absolute inset-0 animate-fire-gradient pointer-events-none z-0" data-id="element-108" />
                        <div className="absolute top-4 left-4 z-20" data-id="element-109">
                          <span className="inline-block bg-red-600 text-white text-xs font-black uppercase px-4 py-1.5 rounded-full shadow-lg shadow-red-500/30 animate-premium-badge-pulse" data-id="element-110">
                            ⭐ BONO PREMIUM
                          </span>
                        </div>
                        <div className="relative z-10 w-full aspect-[4/3] bg-neutral-900" data-id="element-111">
                          <img src={bonus.src} alt={bonus.title} className="w-full h-full object-cover" data-id="element-112" />
                        </div>
                        <div className="relative z-10 p-6 space-y-4 bg-neutral-900/90 border-t border-red-500/30 flex-1 flex flex-col" data-id="element-113">
                          <div className="flex-1" data-id="element-114">
                            <h4 className="text-xl font-black text-white mb-2 uppercase" data-id="element-115">
                              {'BONO PREMIUM: M\xC1QUINAS DE GIMNASIO RENTABLES (+500 PLANOS)'}
                            </h4>
                            <p className="text-neutral-300 text-sm" data-id="element-116">
                              <span className="text-yellow-400 font-black" data-id="element-117">
                                +500 PLANOS AHORA
                              </span>{' '}
                              de fabricación de máquinas de gimnasio
                              industriales. Edición especial con diseños
                              probados de alta demanda.
                            </p>
                          </div>
                          <div className="flex items-center gap-2 py-2" data-id="element-118">
                            <span className="relative flex items-center justify-center" style={{
                      width: 12,
                      height: 12
                    }} data-id="element-119">
                              <span className="absolute inset-0 rounded-full bg-red-500 animate-led-blink" data-id="element-120"></span>
                              <span className="relative rounded-full bg-red-400" style={{
                        width: 8,
                        height: 8
                      }} data-id="element-121"></span>
                            </span>
                            <span className="text-red-400 text-xs font-black uppercase" data-id="element-122">
                              ¡ÚLTIMOS {bonusCupos} CUPOS DISPONIBLES CON ESTE
                              BONO!
                            </span>
                          </div>
                          <div className="flex items-center justify-between pt-3 border-t border-neutral-700" data-id="element-123">
                            <span className="text-neutral-500 line-through text-sm font-bold" data-id="element-124">
                              {bonus.price}
                            </span>
                            <div className="flex items-center gap-1.5 bg-red-500/20 px-4 py-1.5 rounded border border-red-500/40 animate-incluido-glow" data-id="element-125">
                              <Check className="w-3.5 h-3.5 text-red-400 animate-check-bounce" data-id="element-126" />
                              <span className="text-red-400 text-xs font-black uppercase" data-id="element-127">
                                INCLUIDO HOY
                              </span>
                            </div>
                          </div>
                        </div>
                      </ScrollToBuy> : <ScrollToBuy className="h-full group bg-neutral-900 rounded-xl overflow-hidden border border-yellow-500 shadow-lg shadow-yellow-500/5 flex flex-col" data-id="element-128">
                        <div className="w-full aspect-[4/3] bg-neutral-900" data-id="element-129">
                          <img src={bonus.src} alt={bonus.title} className="w-full h-full object-cover" data-id="element-130" />
                        </div>
                        <div className="p-6 space-y-4 bg-neutral-800/50 border-t border-neutral-800 flex-1 flex flex-col" data-id="element-131">
                          <div className="flex-1" data-id="element-132">
                            <h4 className="text-lg font-black text-white mb-2 uppercase" data-id="element-133">
                              {bonus.title}
                            </h4>
                            <p className="text-neutral-400 text-sm" data-id="element-134">
                              {bonus.desc}
                            </p>
                          </div>
                          <div className="flex items-center justify-between pt-3 border-t border-neutral-700" data-id="element-135">
                            <span className="text-neutral-500 line-through text-sm font-bold" data-id="element-136">
                              {bonus.price}
                            </span>
                            <div className="flex items-center gap-1.5 bg-green-500/10 px-3 py-1 rounded border border-green-500/20" data-id="element-137">
                              <Check className="w-3 h-3 text-green-500" data-id="element-138" />
                              <span className="text-green-500 text-xs font-black uppercase" data-id="element-139">
                                INCLUIDO
                              </span>
                            </div>
                          </div>
                        </div>
                      </ScrollToBuy>}
                  </div>)}
              </div>)}
          </div>
        </div>
        <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 bg-neutral-900/80 p-2 rounded-full border border-neutral-700 text-white hover:bg-neutral-800 transition-colors z-20 hidden md:block" data-id="element-140">
          <ChevronLeft className="w-6 h-6" data-id="element-141" />
        </button>
        <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 bg-neutral-900/80 p-2 rounded-full border border-neutral-700 text-white hover:bg-neutral-800 transition-colors z-20 hidden md:block" data-id="element-142">
          <ChevronRight className="w-6 h-6" data-id="element-143" />
        </button>
        <div className="mt-6 flex flex-col items-center gap-3" data-id="element-144">
          <div className="flex justify-center gap-2" data-id="element-145">
            {Array.from({
            length: Math.ceil(BONUS_IMAGES.length / itemsPerSlide)
          }).map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`h-1.5 rounded-full transition-all duration-300 ${idx === currentIndex ? 'w-8 bg-yellow-500' : 'w-2 bg-neutral-700'}`} data-id="element-146" />)}
          </div>
          <p className="text-white text-[13px] flex items-center gap-2 animate-pulse" data-id="element-147">
            Desliza para ver todos los bonos{' '}
            <span className="animate-arrow-vibrate" data-id="element-148">⮕</span>
          </p>
        </div>
      </div>
    </section>;
};
const CompactAccessSection = () => <section className="bg-neutral-900 border border-neutral-800 rounded-xl p-6 md:p-8" data-id="element-149">
    <div className="text-center mb-6" data-id="element-150">
      <ScrollReveal data-id="element-151">
        <span className="inline-block bg-yellow-500/20 border border-yellow-500/50 text-yellow-400 text-xs font-bold uppercase px-3 py-1 rounded-full mb-3" data-id="element-152">
          ACCESO COMPLETO DISPONIBLE HOY
        </span>
      </ScrollReveal>
      <ScrollReveal delay={1} data-id="element-153">
        <h3 className="text-xl md:text-2xl font-black text-white uppercase" data-id="element-154">
          MAESTRO DE MUEBLES INDUSTRIALES 2026 +{' '}
          <span className="text-yellow-500" data-id="element-155">6 BONOS</span>
        </h3>
      </ScrollReveal>
    </div>
    <ScrollReveal delay={2} type="fade-up" data-id="element-156">
      <div className="mb-8" data-id="element-157">
        <img src={BUNDLE_HERO_IMG} alt="Pack Completo con Bonos" className="w-[90%] mx-auto rounded-lg" data-id="element-158" />
      </div>
    </ScrollReveal>
    <ScrollReveal delay={3} data-id="element-159">
      <p className="text-neutral-400 text-sm mt-2 max-w-lg mx-auto text-center mb-6" data-id="element-160">
        Accedés al sistema completo de planos industriales para fabricar con
        método, cobrar como profesional y dejar de improvisar.
      </p>
    </ScrollReveal>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl mx-auto" data-id="element-161">
      {['Ebook Maestro de Muebles Industriales', '+600 planos industriales listos para fabricar', 'Sistema de presupuesto y cierre', 'Manual de soldadura + formación teórica', 'Proyectos especiales: trailers y portones', '+500 planos de máquinas de gimnasio', '6 bonos extra incluidos hoy'].map((item, i) => <ScrollReveal key={i} delay={4 + i} data-id="element-162">
          <div className="flex items-center gap-2" data-id="element-163">
            <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-164" />
            <span className="text-neutral-300 text-sm" data-id="element-165">{item}</span>
          </div>
        </ScrollReveal>)}
    </div>
  </section>;
const DynamicPurchaseCard = () => {
  const [displayViewers, setDisplayViewers] = useState(48);
  const [spots, setSpots] = useState(13);
  const [members, setMembers] = useState(5462);
  const [currentDate, setCurrentDate] = useState('');
  const [viewerFade, setViewerFade] = useState(false);
  const viewerIntervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const spotsIntervalRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    setCurrentDate(new Date().toLocaleDateString('es-AR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }));
    const storedSpots = localStorage.getItem('promo_spots_v3');
    const storedMembers = localStorage.getItem('promo_members_v3');
    const storedTime = localStorage.getItem('promo_time_v3');
    const now = Date.now();
    if (storedSpots && storedMembers && storedTime && now - parseInt(storedTime) <= 86400000) {
      setSpots(Math.max(2, parseInt(storedSpots)));
      setMembers(parseInt(storedMembers));
    } else {
      setSpots(13);
      setMembers(5462);
      localStorage.setItem('promo_spots_v3', '13');
      localStorage.setItem('promo_members_v3', '5462');
      localStorage.setItem('promo_time_v3', String(now));
    }
    const iv = 35 + Math.floor(Math.random() * 28);
    setDisplayViewers(iv);
    viewerIntervalRef.current = setInterval(() => {
      setViewerFade(true);
      setTimeout(() => {
        setDisplayViewers(prev => {
          const change = Math.floor(Math.random() * 9) - 4;
          let next = prev + change;
          if (next < 35) next = 35 + Math.floor(Math.random() * 5);
          if (next > 62) next = 62 - Math.floor(Math.random() * 5);
          return next;
        });
        setViewerFade(false);
      }, 150);
    }, 3000);
    const updateSpots = () => {
      setSpots(prev => {
        if (prev > 2) {
          const nv = prev - 1;
          localStorage.setItem('promo_spots_v3', String(nv));
          setMembers(prevM => {
            const nm = prevM + 1;
            localStorage.setItem('promo_members_v3', String(nm));
            return nm;
          });
          return nv;
        }
        return prev;
      });
      spotsIntervalRef.current = setTimeout(updateSpots, 40000 + Math.random() * 60000);
    };
    spotsIntervalRef.current = setTimeout(updateSpots, 40000 + Math.random() * 60000);
    return () => {
      if (viewerIntervalRef.current) clearInterval(viewerIntervalRef.current);
      if (spotsIntervalRef.current) clearTimeout(spotsIntervalRef.current);
    };
  }, []);
  const handleMainCheckout = () => {
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'Maestro de Muebles Industriales',
        content_category: 'Ebook',
        value: 19990.0,
        currency: 'ARS'
      });
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: 'Maestro de Muebles Industriales',
        value: 19990.0,
        currency: 'ARS'
      });
    }
    window.location.href = MAIN_CHECKOUT_URL;
  };
  return <div id="compra" className="w-full max-w-2xl mx-auto" data-id="element-166">
      <div className="bg-neutral-950 rounded-xl border-2 border-yellow-500 shadow-2xl overflow-hidden animate-neon-yellow" data-id="element-167">
        {/* Offer header */}
        <div className="bg-neutral-900 py-4 px-4 text-center border-b border-yellow-500/30" data-id="element-168">
          <h2 className="text-yellow-400 font-black text-xl md:text-2xl uppercase tracking-wide" data-id="element-169">
            OFERTA VÁLIDA
          </h2>
          <p className="text-white text-sm mt-1" data-id="element-170">Solo por hoy: {currentDate}</p>
        </div>

        <div className="p-6 md:p-8 space-y-6" data-id="element-171">
          {/* Pricing */}
          <div className="text-center space-y-2" data-id="element-172">
            <img src="https://cdn.magicpatterns.com/uploads/otRypCHEiA8UgBVwb9CDEE/redisename_esta_imagen_202603261619.png" alt="Maestro de Muebles Industriales" className="w-full max-w-md mx-auto rounded-lg" data-id="element-173" />
            <p className="text-neutral-500 text-lg line-through decoration-neutral-600 decoration-2 font-bold" data-id="element-174">
              $59.900 ARS
            </p>
            <div className="flex items-baseline justify-center gap-2" data-id="element-175">
              <span className="text-5xl md:text-7xl font-black tracking-tight animate-number-glow text-[#59FF34]" data-id="element-176">
                $19.990
              </span>
              <span className="text-xl font-bold text-yellow-400" data-id="element-177">ARS</span>
            </div>
          </div>

          {/* Body text */}
          <p className="text-white text-center text-sm md:text-base leading-relaxed max-w-md mx-auto" data-id="element-178">
            Llevate el Manual Principal + más de{' '}
            <span className="font-black text-yellow-400" data-id="element-179">
              500 PLANOS DE MÁQUINAS DE GYM
            </span>{' '}
            + 5 bonos extras de regalo
          </p>

          {/* Cuotas */}
          <div className="flex justify-center" data-id="element-180">
            <div className="inline-flex items-center gap-2 bg-neutral-900 px-5 py-2.5 rounded-full border border-neutral-700" data-id="element-181">
              <CreditCard className="w-4 h-4 text-green-500" data-id="element-182" />
              <span className="text-sm font-medium text-neutral-300" data-id="element-183">
                Hasta 3 cuotas sin interés
              </span>
            </div>
          </div>

          {/* Urgency counters */}
          <div className="bg-neutral-900/80 backdrop-blur border border-neutral-700 rounded-xl px-5 py-4 space-y-3" data-id="element-184">
            <div className="flex items-center gap-3" data-id="element-185">
              <span className="relative flex items-center justify-center" style={{
              width: 14,
              height: 14
            }} data-id="element-186">
                <span className="absolute inset-0 rounded-full bg-green-500 animate-led-blink" data-id="element-187"></span>
                <span className="relative rounded-full bg-green-400" style={{
                width: 10,
                height: 10
              }} data-id="element-188"></span>
              </span>
              <span className={`text-sm font-bold text-white transition-opacity duration-150 ${viewerFade ? 'opacity-50' : 'opacity-100'}`} data-id="element-189">
                {displayViewers} personas viendo esta página ahora
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-190">
              <span className="relative flex items-center justify-center" style={{
              width: 14,
              height: 14
            }} data-id="element-191">
                <span className="absolute inset-0 rounded-full bg-red-500 animate-led-blink" data-id="element-192"></span>
                <span className="relative rounded-full bg-red-400" style={{
                width: 10,
                height: 10
              }} data-id="element-193"></span>
              </span>
              <span className="text-sm font-bold text-white" data-id="element-194">
                Quedan {spots} cupos con precio promocional
              </span>
            </div>
          </div>

          {/* Members box */}
          <div className="bg-neutral-900 border border-yellow-500/30 rounded-xl py-5 px-6 text-center pt-[0px] pb-[0px]" data-id="element-195">
            <p className="md:text-5xl font-black text-yellow-400 tracking-tight animate-neon-text-glow text-[24px]" data-id="element-196">
              +{members.toLocaleString('es-AR')}
            </p>
            <p className="text-white font-bold text-xs uppercase tracking-widest mt-1" data-id="element-197">
              PERSONAS YA ACCEDIERON
            </p>
          </div>

          {/* CTA Button */}
          <button onClick={handleMainCheckout} className="w-full bg-yellow-400 hover:bg-yellow-300 text-black font-black md:text-lg py-4 rounded-xl shadow-[0_4px_20px_rgba(250,204,21,0.4)] uppercase tracking-wide transition-all duration-300 transform hover:scale-[1.02] animate-shine-sweep animate-cta-pulse text-[20px] pt-[30px] pb-[30px]" data-id="element-198">
            SÍ, QUIERO ACCEDER
          </button>

          {/* Medios de pago */}
          <div className="border-t border-neutral-800 pt-5" data-id="element-199">
            <p className="text-neutral-500 text-xs uppercase tracking-widest text-center mb-3 font-bold" data-id="element-200">
              MEDIOS DE PAGO
            </p>
            <div className="flex justify-center" data-id="element-201">
              <div className="w-full max-w-[300px] bg-white rounded-lg p-2" data-id="element-202">
                <img src={MERCADO_PAGO_CHECKOUT} alt="Mercado Pago" className="w-full object-contain" data-id="element-203" />
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 text-left border-t border-neutral-800 pt-6" data-id="element-204">
            <div className="bg-neutral-950/80 p-5 rounded-xl border border-neutral-700/50 flex items-center gap-5" data-id="element-205">
              <div className="shrink-0 bg-green-900/30 rounded-xl flex items-center justify-center" style={{
              width: 80,
              height: 80
            }} data-id="element-206">
                <img src={COMPRA_SEGURA_IMG} alt="Compra Segura" className="object-contain" style={{
                width: '75%',
                height: '75%'
              }} data-id="element-207" />
              </div>
              <div data-id="element-208">
                <h4 className="font-black text-white text-base uppercase mb-1.5 tracking-wide" data-id="element-209">
                  PAGO 100% ENCRIPTADO
                </h4>
                <p className="text-neutral-300 text-sm leading-relaxed" data-id="element-210">
                  Procesamos tu compra a través de plataformas líderes con
                  seguridad SSL para proteger tus datos en todo momento.
                </p>
              </div>
            </div>
            <div className="bg-neutral-950/80 p-5 rounded-xl border border-neutral-700/50 flex items-center gap-5" data-id="element-211">
              <div className="shrink-0 bg-green-900/30 rounded-xl flex items-center justify-center" style={{
              width: 80,
              height: 80
            }} data-id="element-212">
                <img src={GARANTIA_IMG} alt="Garantía 7 Días" className="object-contain" style={{
                width: '75%',
                height: '75%'
              }} data-id="element-213" />
              </div>
              <div data-id="element-214">
                <h4 className="font-black text-white text-base uppercase mb-1.5 tracking-wide" data-id="element-215">
                  GARANTÍA SIN RIESGO
                </h4>
                <p className="text-neutral-300 text-sm leading-relaxed" data-id="element-216">
                  Tenés 7 días para validar la calidad del material. Si el
                  contenido no coincide con lo detallado en esta página, te
                  devolvemos el 100% de tu inversión.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
const ReviewsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [newReview, setNewReview] = useState({
    name: '',
    text: '',
    rating: 5
  });
  const [hoverRating, setHoverRating] = useState(0);
  const [userReview, setUserReview] = useState<{
    name: string;
    text: string;
    rating: number;
  } | null>(null);
  const [toast, setToast] = useState(false);
  const visibleReviews = showAll ? CURATED_REVIEWS : CURATED_REVIEWS.slice(0, 3);
  const remainingCount = CURATED_REVIEWS.length - 3;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newReview.name.trim() || !newReview.text.trim()) return;
    setUserReview({
      ...newReview
    });
    setNewReview({
      name: '',
      text: '',
      rating: 5
    });
    setShowForm(false);
    setToast(true);
    setTimeout(() => setToast(false), 3000);
  };
  return <section className="pt-12 pb-4 bg-neutral-900 text-white border-t border-neutral-800 relative" data-id="element-217">
      {toast && <div className="fixed top-24 left-1/2 -translate-x-1/2 bg-neutral-800 border border-green-500/50 text-white px-6 py-4 rounded-lg shadow-2xl z-50 flex items-center gap-3" data-id="element-218">
          <div className="bg-green-500/20 p-1 rounded-full" data-id="element-219">
            <Check className="w-5 h-5 text-green-500" data-id="element-220" />
          </div>
          <p className="font-medium text-sm" data-id="element-221">Gracias por tu comentario</p>
        </div>}
      <div className="max-w-4xl mx-auto px-4" data-id="element-222">
        <div className="text-center mb-12 space-y-4" data-id="element-223">
          <ScrollReveal data-id="element-224">
            <h3 className="text-3xl font-black text-white uppercase" data-id="element-225">
              Lo que dicen quienes ya fabrican con método
            </h3>
          </ScrollReveal>
          <ScrollReveal delay={1} data-id="element-226">
            <div className="flex flex-col items-center gap-1" data-id="element-227">
              <p className="text-xl font-medium text-white" data-id="element-228">
                Más de 5.600 herreros satisfechos
              </p>
              <div className="flex gap-1" data-id="element-229">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 text-yellow-500 fill-yellow-500" data-id="element-230" />)}
              </div>
              <p className="text-sm text-neutral-400" data-id="element-231">
                4,9/5 · reseñas verificadas
              </p>
            </div>
          </ScrollReveal>
        </div>

        <div className="space-y-4 mb-8" data-id="element-232">
          {userReview && <div className="bg-neutral-800 p-6 rounded border border-yellow-500/30" data-id="element-233">
              <div className="flex gap-1 mb-3" data-id="element-234">
                {[...Array(5)].map((_, idx) => <Star key={idx} className={`w-4 h-4 ${idx < userReview.rating ? 'text-yellow-500 fill-yellow-500' : 'text-neutral-600'}`} data-id="element-235" />)}
              </div>
              <p className="text-neutral-300 mb-4 italic" data-id="element-236">
                "{userReview.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-237">
                <div className="w-8 h-8 bg-yellow-500/20 rounded-full flex items-center justify-center text-yellow-500 font-bold text-xs border border-yellow-500/30" data-id="element-238">
                  {userReview.name.charAt(0)}
                </div>
                <div data-id="element-239">
                  <p className="font-bold text-sm text-white" data-id="element-240">
                    {userReview.name}
                  </p>
                  <p className="text-xs text-neutral-500" data-id="element-241">Tu reseña</p>
                </div>
              </div>
            </div>}

          {visibleReviews.map((review, i) => <div key={i} className="bg-neutral-800 p-6 rounded border border-neutral-700" data-id="element-242">
              <div className="flex gap-1 mb-3" data-id="element-243">
                {[...Array(5)].map((_, idx) => <Star key={idx} className={`w-4 h-4 ${idx < review.rating ? 'text-yellow-500 fill-yellow-500' : 'text-neutral-600'}`} data-id="element-244" />)}
              </div>
              <p className="text-neutral-300 mb-4 italic" data-id="element-245">"{review.text}"</p>
              <div className="flex items-center gap-3" data-id="element-246">
                <div className="w-8 h-8 bg-neutral-700 rounded-full flex items-center justify-center text-yellow-500 font-bold text-xs border border-neutral-600" data-id="element-247">
                  {review.name.charAt(0)}
                </div>
                <div data-id="element-248">
                  <p className="font-bold text-sm text-white" data-id="element-249">{review.name}</p>
                  <p className="text-xs text-neutral-500" data-id="element-250">{review.location}</p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="flex flex-col items-center gap-6" data-id="element-251">
          {!showAll && remainingCount > 0 && <button onClick={() => setShowAll(true)} className="text-neutral-400 hover:text-white text-sm font-medium transition-colors" data-id="element-252">
              Ver {remainingCount} comentarios más
            </button>}

          {!userReview && <button onClick={() => setShowForm(!showForm)} className="bg-neutral-800 hover:bg-neutral-700 text-white px-6 py-3 rounded border border-neutral-700 font-medium transition-colors flex items-center gap-2" data-id="element-253">
              <MessageSquare className="w-4 h-4" data-id="element-254" />
              Dejar mi reseña
            </button>}

          {showForm && <div className="bg-neutral-800 p-6 rounded border border-neutral-700 max-w-xl w-full" data-id="element-255">
              <h4 className="font-bold text-lg mb-4 text-center text-yellow-500" data-id="element-256">
                Tu opinión nos importa
              </h4>
              <form onSubmit={handleSubmit} className="space-y-4" data-id="element-257">
                <input type="text" placeholder="Tu nombre" className="w-full p-3 rounded bg-neutral-900 border border-neutral-700 text-white focus:border-yellow-500 outline-none" value={newReview.name} onChange={e => setNewReview({
              ...newReview,
              name: e.target.value
            })} data-id="element-258" />
                <textarea placeholder="Tu experiencia con los planos..." rows={3} className="w-full p-3 rounded bg-neutral-900 border border-neutral-700 text-white focus:border-yellow-500 outline-none resize-none" value={newReview.text} onChange={e => setNewReview({
              ...newReview,
              text: e.target.value
            })} data-id="element-259" />
                <div className="flex items-center gap-3" data-id="element-260">
                  <span className="text-sm text-neutral-400" data-id="element-261">
                    Calificación:
                  </span>
                  <div className="flex gap-1" data-id="element-262">
                    {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" onMouseEnter={() => setHoverRating(star)} onMouseLeave={() => setHoverRating(0)} onClick={() => setNewReview({
                  ...newReview,
                  rating: star
                })} className="p-1" data-id="element-263">
                        <Star className={`w-6 h-6 ${(hoverRating ? star <= hoverRating : star <= newReview.rating) ? 'text-yellow-500 fill-yellow-500' : 'text-neutral-600'}`} data-id="element-264" />
                      </button>)}
                  </div>
                </div>
                <button type="submit" className="w-full bg-yellow-500 hover:bg-yellow-400 text-black font-bold py-3 rounded transition-colors" data-id="element-265">
                  Enviar reseña
                </button>
              </form>
            </div>}
        </div>
      </div>
    </section>;
};
const FabricarSection = () => <section className="space-y-8" data-id="element-266">
    <div className="text-center space-y-2" data-id="element-267">
      <ScrollReveal data-id="element-268">
        <h3 className="text-3xl font-black text-white uppercase" data-id="element-269">
          Mirá todo lo que vas a poder{' '}
          <span className="text-yellow-500" data-id="element-270">FABRICAR</span>
        </h3>
      </ScrollReveal>
      <ScrollReveal delay={1} data-id="element-271">
        <p className="text-neutral-400 font-medium" data-id="element-272">
          Cada diseño está probado por herreros reales en Argentina
        </p>
      </ScrollReveal>
    </div>
    <div className="grid md:grid-cols-3 gap-6" data-id="element-273">
      <ScrollReveal delay={2} data-id="element-274">
        <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-6 flex flex-col h-full relative overflow-hidden" data-id="element-275">
          <div className="flex items-center gap-3 mb-4" data-id="element-276">
            <Hammer className="text-yellow-500 w-5 h-5" data-id="element-277" />
            <h4 className="text-lg font-bold text-yellow-500" data-id="element-278">
              Muebles de Acero y Madera
            </h4>
          </div>
          <ul className="space-y-3 mb-6 flex-1" data-id="element-279">
            {['Alta demanda real', 'Se venden todo el año', 'Precios 3-4x más altos'].map((item, j) => <li key={j} className="flex items-start gap-2 text-sm text-neutral-400" data-id="element-280">
                <Check className="w-4 h-4 text-yellow-500 mt-0.5 shrink-0" data-id="element-281" />
                {item}
              </li>)}
          </ul>
          <div className="mt-auto flex justify-center" data-id="element-282">
            <div className="flex items-center gap-2 bg-red-600 rounded-lg py-2 px-4 w-fit mx-auto animate-glow-pulse-red shadow-lg" data-id="element-283">
              <Star className="w-3.5 h-3.5 text-white fill-white" data-id="element-284" />
              <span className="text-xs font-bold uppercase text-white" data-id="element-285">
                EL MÁS PEDIDO
              </span>
            </div>
          </div>
        </div>
      </ScrollReveal>

      <ScrollReveal delay={3} data-id="element-286">
        <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-6 flex flex-col h-full relative overflow-hidden" data-id="element-287">
          <div className="flex items-center gap-3 mb-4" data-id="element-288">
            <Wrench className="text-yellow-500 w-5 h-5" data-id="element-289" />
            <h4 className="text-lg font-bold text-yellow-500" data-id="element-290">
              Portones, Escaleras y Trailers
            </h4>
          </div>
          <p className="text-sm text-neutral-400 mb-6 flex-1 leading-relaxed" data-id="element-291">
            Proyectos de mayor escala y clientes recurrentes. Estructuras
            sólidas y funcionales que aseguran un flujo de caja constante y
            márgenes altos.
          </p>
          <div className="mt-auto flex justify-center" data-id="element-292">
            <div className="flex items-center gap-2 bg-yellow-400 rounded-lg py-2 px-4 w-fit mx-auto animate-glow-pulse-yellow shadow-lg" data-id="element-293">
              <TrendingUp className="w-3.5 h-3.5 text-black" data-id="element-294" />
              <span className="text-xs font-bold uppercase text-black" data-id="element-295">
                ALTA RENTABILIDAD
              </span>
            </div>
          </div>
        </div>
      </ScrollReveal>

      <ScrollReveal delay={4} data-id="element-296">
        <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-6 flex flex-col h-full relative overflow-hidden" data-id="element-297">
          <div className="flex items-center gap-3 mb-4" data-id="element-298">
            <Layout className="text-yellow-500 w-5 h-5" data-id="element-299" />
            <h4 className="text-lg font-bold text-yellow-500" data-id="element-300">
              Máquinas de Gym Profesionales
            </h4>
          </div>
          <p className="text-sm text-neutral-400 mb-6 flex-1 leading-relaxed" data-id="element-301">
            El nicho más rentable y técnico de la actualidad. Equipamiento
            fitness con mecánica probada para un mercado exclusivo que busca
            calidad industrial.
          </p>
          <div className="mt-auto flex justify-center" data-id="element-302">
            <div className="flex items-center gap-2 bg-green-600 rounded-lg py-2 px-4 w-fit mx-auto animate-glow-pulse-green shadow-lg" data-id="element-303">
              <DollarSign className="w-3.5 h-3.5 text-white" data-id="element-304" />
              <span className="text-xs font-bold uppercase text-white" data-id="element-305">
                MÁXIMA RENTABILIDAD
              </span>
            </div>
          </div>
        </div>
      </ScrollReveal>
    </div>
  </section>;
const EbookPreviewSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const nextSlide = useCallback(() => setCurrentIndex(prev => (prev + 1) % EBOOK_PREVIEW_IMAGES.length), []);
  const prevSlide = useCallback(() => setCurrentIndex(prev => (prev - 1 + EBOOK_PREVIEW_IMAGES.length) % EBOOK_PREVIEW_IMAGES.length), []);
  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(nextSlide, 3000);
    return () => clearInterval(interval);
  }, [isPaused, nextSlide]);
  return <section className="space-y-8" data-id="element-306">
      <div className="text-center space-y-2" data-id="element-307">
        <ScrollReveal data-id="element-308">
          <h3 className="text-2xl md:text-3xl font-black text-white" data-id="element-309">
            Así se ve por dentro el ebook
          </h3>
        </ScrollReveal>
        <ScrollReveal delay={1} data-id="element-310">
          <p className="text-neutral-400 text-sm md:text-base" data-id="element-311">
            Ejemplos reales de páginas, planos y guías incluidas en Maestro de
            Muebles Industriales
          </p>
        </ScrollReveal>
      </div>
      <div className="relative overflow-hidden rounded-xl bg-neutral-900 border border-neutral-800 max-w-md mx-auto shadow-2xl" onTouchStart={e => {
      touchStartX.current = e.touches[0].clientX;
      setIsPaused(true);
    }} onTouchMove={e => {
      touchEndX.current = e.touches[0].clientX;
    }} onTouchEnd={() => {
      const diff = touchStartX.current - touchEndX.current;
      if (Math.abs(diff) > 50) {
        diff > 0 ? nextSlide() : prevSlide();
      }
      setTimeout(() => setIsPaused(false), 5000);
    }} onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-id="element-312">
        <div className="flex transition-transform duration-500 ease-in-out" style={{
        transform: `translateX(-${currentIndex * 100}%)`
      }} data-id="element-313">
          {EBOOK_PREVIEW_IMAGES.map((img, idx) => <div key={idx} className="w-full flex-shrink-0" data-id="element-314">
              <img src={img} alt={`Página del ebook ${idx + 1}`} className="w-full aspect-[9/16] object-contain bg-white" data-id="element-315" />
            </div>)}
        </div>
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2" data-id="element-316">
          {EBOOK_PREVIEW_IMAGES.map((_, idx) => <button key={idx} onClick={() => {
          setCurrentIndex(idx);
          setIsPaused(true);
          setTimeout(() => setIsPaused(false), 5000);
        }} className={`w-2 h-2 rounded-full transition-colors ${idx === currentIndex ? 'bg-yellow-500' : 'bg-neutral-600'}`} data-id="element-317" />)}
        </div>
      </div>
      <p className="text-center text-neutral-400 text-sm" data-id="element-318">
        <span className="text-yellow-500 font-medium" data-id="element-319">Planos claros</span>,{' '}
        <span className="text-yellow-500 font-medium" data-id="element-320">medidas exactas</span> y{' '}
        <span className="text-yellow-500 font-medium" data-id="element-321">criterio industrial</span>{' '}
        aplicado a cada proyecto.
      </p>
    </section>;
};
const TrustSection = () => <section className="bg-[#1a1a1a] border border-yellow-500/20 rounded-xl p-8 md:p-10" data-id="element-322">
    <div className="text-center mb-8" data-id="element-323">
      <ScrollReveal data-id="element-324">
        <h3 className="text-xl md:text-2xl font-black text-white flex items-center justify-center gap-2" data-id="element-325">
          <Lock className="w-5 h-5 text-yellow-500" data-id="element-326" />
          Compra segura y acceso inmediato
        </h3>
      </ScrollReveal>
      <ScrollReveal delay={1} data-id="element-327">
        <p className="text-neutral-400 text-sm mt-2" data-id="element-328">
          Este material fue creado para que trabajes con tranquilidad, claridad
          y respaldo desde el primer día.
        </p>
      </ScrollReveal>
    </div>
    <div className="grid sm:grid-cols-2 gap-4 max-w-2xl mx-auto" data-id="element-329">
      {[{
      icon: Zap,
      color: 'text-green-500',
      title: 'Acceso inmediato',
      desc: 'Recibís el material completo apenas se confirma el pago.'
    }, {
      icon: Download,
      color: 'text-green-500',
      title: 'Descarga segura y privada',
      desc: 'Tus archivos están protegidos y disponibles para siempre.'
    }, {
      icon: ShieldCheck,
      color: 'text-yellow-500',
      title: 'Garantía de satisfacción 7 días',
      desc: 'Si no es lo que esperabas, podés solicitar la devolución.'
    }, {
      icon: BookOpen,
      color: 'text-yellow-500',
      title: 'Producto digital profesional',
      desc: 'Planos claros, medidas exactas y criterio industrial real.'
    }].map((item, i) => <ScrollReveal key={i} delay={2 + i} data-id="element-330">
          <div className="flex items-start gap-3 p-4 bg-neutral-900/50 rounded-lg" data-id="element-331">
            <item.icon className={`w-5 h-5 ${item.color} shrink-0 mt-0.5`} data-id="element-332" />
            <div data-id="element-333">
              <p className="text-white font-bold text-sm" data-id="element-334">{item.title}</p>
              <p className="text-neutral-400 text-xs" data-id="element-335">{item.desc}</p>
            </div>
          </div>
        </ScrollReveal>)}
    </div>
    <ScrollReveal delay={6} data-id="element-336">
      <p className="text-center text-neutral-500 text-sm mt-6" data-id="element-337">
        Más de 3.200 herreros y fabricantes ya trabajan con este sistema.
      </p>
    </ScrollReveal>
  </section>;
const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="space-y-8" data-id="element-338">
      <div className="text-center space-y-2" data-id="element-339">
        <ScrollReveal data-id="element-340">
          <h3 className="text-2xl md:text-3xl font-black text-white" data-id="element-341">
            Resolvé acá tus dudas antes de comprar
          </h3>
        </ScrollReveal>
        <ScrollReveal delay={1} data-id="element-342">
          <p className="text-neutral-400" data-id="element-343">
            Todo lo que necesitás saber sobre el acceso y el contenido
          </p>
        </ScrollReveal>
      </div>
      <div className="max-w-2xl mx-auto space-y-3" data-id="element-344">
        {FAQ_DATA.map((faq, i) => <ScrollReveal key={i} delay={2 + i} data-id="element-345">
            <div className="bg-[#1a1a1a] border border-neutral-700/50 rounded-lg overflow-hidden" data-id="element-346">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full p-5 flex items-center justify-between text-left" data-id="element-347">
                <div className="flex items-center gap-3" data-id="element-348">
                  <HelpCircle className="w-5 h-5 text-yellow-500 shrink-0" data-id="element-349" />
                  <span className="text-white font-medium" data-id="element-350">{faq.q}</span>
                </div>
                <ChevronDown className={`w-5 h-5 text-neutral-400 transition-transform ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-351" />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === i ? 'max-h-40' : 'max-h-0'}`} data-id="element-352">
                <p className="px-5 pb-5 text-neutral-400 text-sm pl-13" data-id="element-353">
                  {faq.a}
                </p>
              </div>
            </div>
          </ScrollReveal>)}
      </div>
    </section>;
};
const CSS_STYLES = `
/* === HERO ENTRANCE === */
@keyframes hero-zoom { 0% { opacity: 0; transform: scale(1.03); } 100% { opacity: 1; transform: scale(1); } }
.animate-hero-zoom { animation: hero-zoom 0.9s cubic-bezier(0.16, 1, 0.3, 1) forwards; }

@keyframes float-up-entry { 0% { opacity: 0; transform: translateY(40px); } 100% { opacity: 1; transform: translateY(0); } }
.animate-float-up-entry { animation: float-up-entry 0.9s cubic-bezier(0.16, 1, 0.3, 1) forwards; opacity: 0; }

@keyframes fade-up { 0% { opacity: 0; transform: translateY(16px); } 100% { opacity: 1; transform: translateY(0); } }
.animate-fade-up { animation: fade-up 0.7s cubic-bezier(0.16, 1, 0.3, 1) forwards; opacity: 0; }

@keyframes pop-scale { 0% { opacity: 0; transform: scale(0.98); } 60% { transform: scale(1.02); } 100% { opacity: 1; transform: scale(1); } }
.animate-pop-scale { animation: pop-scale 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards; opacity: 0; }

/* === TYPE REVEAL === */
@keyframes type-reveal { from { opacity: 0; transform: translateY(4px); } to { opacity: 1; transform: translateY(0); } }
.char-reveal { display: inline-block; opacity: 0; animation: type-reveal 0.04s cubic-bezier(0.16, 1, 0.3, 1) forwards; }

/* === LEGACY SCROLL ANIMATIONS (FearToSystemCard compat) === */
@keyframes fade-in-down { from { opacity: 0; transform: translateY(-20px); } to { opacity: 1; transform: translateY(0); } }
.animate-fade-in-down { animation: fade-in-down 0.7s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
.animate-fade-in-down-delay-1 { animation: fade-in-down 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.12s forwards; opacity: 0; }
.animate-fade-in-down-delay-2 { animation: fade-in-down 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.24s forwards; opacity: 0; }
.animate-fade-in-down-delay-3 { animation: fade-in-down 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.36s forwards; opacity: 0; }

/* === DOT PULSE (LIVE INDICATOR) === */
@keyframes dot-pulse-green {
  0%, 100% { transform: scale(1); opacity: 1; box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
  50% { transform: scale(1.25); opacity: 0.55; box-shadow: 0 0 8px 3px rgba(34, 197, 94, 0.25); }
}
.animate-dot-pulse-green { animation: dot-pulse-green 1.2s ease-in-out infinite; }

@keyframes dot-pulse-red {
  0%, 100% { transform: scale(1); opacity: 1; box-shadow: 0 0 0 0 rgba(239, 68, 68, 0); }
  50% { transform: scale(1.25); opacity: 0.55; box-shadow: 0 0 8px 3px rgba(239, 68, 68, 0.25); }
}
.animate-dot-pulse-red { animation: dot-pulse-red 1.2s ease-in-out infinite; }

/* === BUTTON SHINE === */
@keyframes shine-global { 0% { left: -100%; } 15% { left: 100%; } 100% { left: 100%; } }
.animate-shine { position: relative; overflow: hidden; }
.animate-shine::after { content: ''; position: absolute; top: 0; left: -100%; width: 50%; height: 100%; background: linear-gradient(to right, transparent, rgba(255,255,255,0.5), transparent); transform: skewX(-20deg); animation: shine-global 3s infinite; pointer-events: none; z-index: 1; }

.animate-shine-sweep { position: relative; overflow: hidden; }
.animate-shine-sweep::after { content: ''; position: absolute; top: 0; left: -100%; width: 50%; height: 100%; background: linear-gradient(to right, transparent, rgba(255,255,255,0.5), transparent); transform: skewX(-20deg); animation: shine-global 3s infinite; pointer-events: none; z-index: 1; }

/* === CARD GLOW === */
@keyframes glow-pulse { 0%, 100% { box-shadow: 0 0 20px rgba(234, 179, 8, 0.3); } 50% { box-shadow: 0 0 30px rgba(234, 179, 8, 0.5); } }
.animate-glow-pulse { animation: glow-pulse 3s infinite; }

@keyframes neon-yellow-glow { 0%, 100% { box-shadow: 0 0 15px rgba(250, 204, 21, 0.3), 0 0 30px rgba(250, 204, 21, 0.15); } 50% { box-shadow: 0 0 25px rgba(250, 204, 21, 0.5), 0 0 50px rgba(250, 204, 21, 0.25); } }
.animate-neon-yellow { animation: neon-yellow-glow 2.5s ease-in-out infinite; }

/* === BONUS CARD EFFECTS === */
@keyframes red-glow { 0%, 100% { box-shadow: 0 0 20px rgba(239, 68, 68, 0.2); } 50% { box-shadow: 0 0 30px rgba(239, 68, 68, 0.35); } }
.animate-red-glow { animation: red-glow 3s ease-in-out infinite; }

@keyframes premium-badge-pulse { 0%, 100% { opacity: 1; transform: scale(1); } 50% { opacity: 0.9; transform: scale(1.03); } }
.animate-premium-badge-pulse { animation: premium-badge-pulse 2.5s ease-in-out infinite; }

/* === FABRICAR SECTION BADGES === */
@keyframes glow-pulse-red { 0%, 100% { box-shadow: 0 0 10px rgba(220, 38, 38, 0.5); } 50% { box-shadow: 0 0 20px rgba(220, 38, 38, 0.8); } }
.animate-glow-pulse-red { animation: glow-pulse-red 2s infinite; }

@keyframes glow-pulse-yellow { 0%, 100% { box-shadow: 0 0 10px rgba(250, 204, 21, 0.5); } 50% { box-shadow: 0 0 20px rgba(250, 204, 21, 0.8); } }
.animate-glow-pulse-yellow { animation: glow-pulse-yellow 2s infinite; }

@keyframes glow-pulse-green { 0%, 100% { box-shadow: 0 0 10px rgba(22, 163, 74, 0.5); } 50% { box-shadow: 0 0 20px rgba(22, 163, 74, 0.8); } }
.animate-glow-pulse-green { animation: glow-pulse-green 2s infinite; }

/* === MISC === */
@keyframes arrow-vibrate { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(3px); } 75% { transform: translateX(-3px); } }
.animate-arrow-vibrate { animation: arrow-vibrate 1s ease-in-out infinite; }

/* === NUMBER GLOW === */
@keyframes number-glow {
  0%, 100% { text-shadow: 0 0 10px rgba(253, 224, 71, 0.3), 0 0 20px rgba(253, 224, 71, 0.1); }
  50% { text-shadow: 0 0 20px rgba(253, 224, 71, 0.6), 0 0 40px rgba(253, 224, 71, 0.3); }
}
.animate-number-glow { animation: number-glow 2.5s ease-in-out infinite; }

/* === NEON TEXT GLOW (constant bright) === */
@keyframes neon-text-glow {
  0%, 100% { text-shadow: 0 0 8px rgba(250, 204, 21, 0.6), 0 0 20px rgba(250, 204, 21, 0.4), 0 0 40px rgba(250, 204, 21, 0.2); }
  50% { text-shadow: 0 0 12px rgba(250, 204, 21, 0.8), 0 0 30px rgba(250, 204, 21, 0.6), 0 0 60px rgba(250, 204, 21, 0.3); }
}
.animate-neon-text-glow { animation: neon-text-glow 1.8s ease-in-out infinite; }

/* === LED BLINK (fast pulse for indicators) === */
@keyframes led-blink {
  0%, 100% { opacity: 1; transform: scale(1); box-shadow: 0 0 4px currentColor; }
  50% { opacity: 0.4; transform: scale(0.85); box-shadow: 0 0 8px currentColor; }
}
.animate-led-blink { animation: led-blink 0.8s ease-in-out infinite; }

/* === FIRE GRADIENT (premium bonus background) === */
@keyframes fire-gradient {
  0% { background: linear-gradient(135deg, rgba(127,29,29,0.3) 0%, rgba(0,0,0,0.1) 50%, rgba(153,27,27,0.2) 100%); }
  33% { background: linear-gradient(135deg, rgba(153,27,27,0.2) 0%, rgba(127,29,29,0.3) 50%, rgba(0,0,0,0.1) 100%); }
  66% { background: linear-gradient(135deg, rgba(0,0,0,0.1) 0%, rgba(153,27,27,0.2) 50%, rgba(127,29,29,0.3) 100%); }
  100% { background: linear-gradient(135deg, rgba(127,29,29,0.3) 0%, rgba(0,0,0,0.1) 50%, rgba(153,27,27,0.2) 100%); }
}
.animate-fire-gradient { animation: fire-gradient 4s ease-in-out infinite; }

/* === BORDER BLINK RED (premium card border) === */
@keyframes border-blink-red {
  0%, 100% { border-color: rgba(239, 68, 68, 1); box-shadow: 0 0 15px rgba(239, 68, 68, 0.3); }
  50% { border-color: rgba(239, 68, 68, 0.3); box-shadow: 0 0 5px rgba(239, 68, 68, 0.1); }
}
.animate-border-blink-red { animation: border-blink-red 1.5s ease-in-out infinite; }

/* === CHECK BOUNCE (animated check icon) === */
@keyframes check-bounce {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.3); }
}
.animate-check-bounce { animation: check-bounce 2s ease-in-out infinite; }

/* === CTA PULSE (subtle shake every 3s) === */
@keyframes cta-pulse {
  0%, 88%, 100% { transform: scale(1) translateX(0); }
  90% { transform: scale(1.02) translateX(-2px); }
  92% { transform: scale(1.02) translateX(2px); }
  94% { transform: scale(1.01) translateX(-1px); }
  96% { transform: scale(1.01) translateX(1px); }
  98% { transform: scale(1) translateX(0); }
}
.animate-cta-pulse { animation: cta-pulse 3s ease-in-out infinite; }

/* === INCLUIDO HOY GLOW === */
@keyframes incluido-glow {
  0%, 100% { box-shadow: 0 0 8px rgba(239, 68, 68, 0.3), 0 0 16px rgba(239, 68, 68, 0.15); }
  50% { box-shadow: 0 0 14px rgba(239, 68, 68, 0.5), 0 0 28px rgba(239, 68, 68, 0.25); }
}
.animate-incluido-glow { animation: incluido-glow 2s ease-in-out infinite; }

/* === STICKY HEADER BUTTON SHAKE === */
@keyframes header-btn-shake {
  0%, 85%, 100% { transform: translateX(0); }
  87% { transform: translateX(-2px) rotate(-1deg); }
  89% { transform: translateX(2px) rotate(1deg); }
  91% { transform: translateX(-2px) rotate(-0.5deg); }
  93% { transform: translateX(2px) rotate(0.5deg); }
  95% { transform: translateX(0); }
}
.animate-header-shake { animation: header-btn-shake 5s ease-in-out infinite; }

/* === REDUCED MOTION === */
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after { animation-duration: 0.01ms !important; animation-iteration-count: 1 !important; transition-duration: 0.01ms !important; }
}
`;
const TypeReveal = ({
  text,
  className = '',
  delay = 0
}: {
  text: string;
  className?: string;
  delay?: number;
}) => {
  return <span className={className} data-id="element-354">
      {text.split('').map((char, i) => <span key={i} className="char-reveal" style={{
      animationDelay: `${delay + i * 0.03}s`
    }} data-id="element-355">
          {char}
        </span>)}
    </span>;
};
export function App() {
  return <div className="min-h-screen bg-neutral-950 text-neutral-200 font-sans selection:bg-yellow-500/30 selection:text-yellow-200" data-id="element-356">
      <style data-id="element-357">{`{CSS_STYLES}`}</style>
      <MetaPixel data-id="element-358" />
      <SocialProofPopup data-id="element-359" />
      <StickyHeader data-id="element-360" />

      <header className="relative pt-12 pb-14 px-4 md:px-8 overflow-hidden animate-hero-zoom" data-id="element-361">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-neutral-900 via-neutral-950 to-black -z-10" data-id="element-362" />
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-64 bg-yellow-600/10 blur-[100px] rounded-full -z-10" data-id="element-363" />
        <div className="max-w-5xl mx-auto text-center space-y-6" data-id="element-364">
          <div className="relative mx-auto max-w-md md:max-w-lg py-8 group cursor-pointer animate-float-up-entry overflow-hidden rounded-2xl pt-[0px] pb-[0px]" style={{
          animationDelay: '0.3s'
        }} onClick={() => document.getElementById('compra')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-365">
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-3/4 h-24 bg-yellow-500/40 blur-[50px] rounded-full" data-id="element-366" />
            <video src="https://cdn.magicpatterns.com/uploads/g2UVoTgU8iQ66uMw8QEu4K/0326 (1)(1).mp4" autoPlay loop muted playsInline className="relative z-10 w-full rounded-xl drop-shadow-2xl transform scale-[1.05] group-hover:scale-[1.08] transition-transform duration-500 ease-out pt-[10px] pb-[10px]" data-id="element-367" />
          </div>
          <div className="flex flex-col items-center gap-1 -mt-4 mb-4 animate-fade-up" style={{
          animationDelay: '1.4s'
        }} data-id="element-368">
            <div className="flex gap-1" data-id="element-369">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3 h-3 text-yellow-500 fill-yellow-500" data-id="element-370" />)}
            </div>
            <span className="text-white font-medium text-xs" data-id="element-371">
              +5.600 herreros y fabricantes satisfechos
            </span>
          </div>
          <div className="flex flex-col items-center gap-8 animate-pop-scale" style={{
          animationDelay: '1.6s'
        }} data-id="element-372">
            <CTAButton text="QUIERO LOS PLANOS AHORA" className="py-3 text-lg" pulse={true} data-id="element-373" />
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 md:px-8 space-y-14 pb-16" data-id="element-374">
        <FearToSystemCard data-id="element-375" />
        <ProblemsSection data-id="element-376" />
        <section className="bg-neutral-900 rounded-xl p-8 md:p-12 border border-neutral-800 shadow-2xl relative overflow-hidden" data-id="element-377">
          <div className="absolute top-0 right-0 w-64 h-64 bg-yellow-600/10 blur-[80px] rounded-full -z-10" data-id="element-378" />
          <div className="text-center space-y-6 mb-12" data-id="element-379">
            <ScrollReveal data-id="element-380">
              <h2 className="text-4xl md:text-5xl font-black text-white uppercase tracking-tight leading-none" data-id="element-381">
                Maestro de <br data-id="element-382" />
                <span className="text-yellow-500" data-id="element-383">Muebles Industriales</span>
              </h2>
            </ScrollReveal>
            <ScrollReveal delay={1} data-id="element-384">
              <p className="text-xl text-neutral-300 font-medium" data-id="element-385">
                Es un ebook práctico creado para una sola cosa:
              </p>
            </ScrollReveal>
            <ScrollReveal delay={2} data-id="element-386">
              <p className="text-2xl font-black text-white uppercase" data-id="element-387">
                Que dejes de improvisar y empieces a fabricar con confianza.
              </p>
            </ScrollReveal>
          </div>
          <div className="grid md:grid-cols-2 gap-8 items-center mb-12" data-id="element-388">
            <ScrollReveal type="fade-left" data-id="element-389">
              <div className="space-y-6" data-id="element-390">
                <div className="rounded-lg overflow-hidden shadow-2xl border border-neutral-800 bg-black" data-id="element-391">
                  <video src="https://cdn.magicpatterns.com/uploads/hGMRq4tpMpnBX8eU3bEx8h/mobile_web.undefined" autoPlay muted loop playsInline className="w-full h-auto block opacity-90" data-id="element-392" />
                </div>
              </div>
            </ScrollReveal>
            <div className="space-y-4" data-id="element-393">
              <ScrollReveal delay={1} data-id="element-394">
                <p className="text-neutral-300" data-id="element-395">
                  No es un PDF de inspiración. No es motivación vacía. No es
                  teoría.
                </p>
              </ScrollReveal>
              <ScrollReveal delay={2} data-id="element-396">
                <p className="text-white font-bold text-lg uppercase" data-id="element-397">
                  Es ejecución real.
                </p>
              </ScrollReveal>
              <ScrollReveal delay={3} data-id="element-398">
                <p className="text-neutral-300" data-id="element-399">Un sistema para que puedas:</p>
              </ScrollReveal>
              <ul className="space-y-3" data-id="element-400">
                {['Empezar un mueble sabiendo exactamente qué hacer', 'Ahorrar tiempo de diseño y prueba/error', 'Evitar errores caros de material y estructura', 'Repetir modelos vendibles (rentables)', 'Cotizar rápido y cobrar con seguridad'].map((item, i) => <ScrollReveal key={i} delay={4 + i} data-id="element-401">
                    <li className="flex items-start gap-3" data-id="element-402">
                      <Check className="text-yellow-500 w-6 h-6 shrink-0" data-id="element-403" />
                      <span className="text-neutral-200 font-medium" data-id="element-404">
                        {item}
                      </span>
                    </li>
                  </ScrollReveal>)}
              </ul>
            </div>
          </div>
          <CTAButton text="QUIERO LOS PLANOS AHORA" data-id="element-405" />
        </section>
        <ProjectsCarousel data-id="element-406" />
        <FabricarSection data-id="element-407" />
        <BonusesSection data-id="element-408" />
        <div data-id="element-409">
          <ReviewsSection data-id="element-410" />
          <div className="space-y-8" data-id="element-411">
            <CompactAccessSection data-id="element-412" />
            <ScrollReveal type="zoom" data-id="element-413">
              <DynamicPurchaseCard data-id="element-414" />
            </ScrollReveal>
          </div>
        </div>
        <EbookPreviewSection data-id="element-415" />
        <TrustSection data-id="element-416" />
        <FAQSection data-id="element-417" />
      </main>

      <footer className="bg-black border-t border-neutral-900 py-12 text-center text-neutral-600 text-sm" data-id="element-418">
        <p data-id="element-419">
          © 2025 Maestro de Muebles Industriales. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-420">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </footer>
    </div>;
}